export const PERSONS_RESOURCE = 'people.persons';
export const FUNCTIONS_RESOURCE = 'people.functions';
export const PERSON_RATES_RESOURCE = 'people.person_rates';
export const PEOPLE_KEY = ['people'] as const;
/** Owner 2026-10-26: ONE order of the functions („Inni” among them) and which of them Obsada's „ⓘ Info” shows. */
export const FUNCTION_SETTINGS_KEY = [...PEOPLE_KEY, 'function-settings'] as const;
export type FunctionSettings = { order: Array<{ id: string; name: string; others: boolean }>; visible: string[]; version: number };

export type Employment = 'etat' | 'staly' | 'zewnetrzny';
export type CostModel = 'staly' | 'indywidualny';
export type Priority = 'niski' | 'normalny' | 'pilny';

export const EMPLOYMENT_LABELS: Record<Employment, string> = { etat: 'Etat', staly: 'Stały współpracownik', zewnetrzny: 'Z zewnątrz' };
export const COST_MODEL_LABELS: Record<CostModel, string> = { staly: 'Stały', indywidualny: 'Indywidualny (wg funkcji)' };
export const PRIORITY_LABELS: Record<Priority, string> = { niski: 'Niski', normalny: 'Normalny', pilny: 'Pilny' };

/** Fields the role may not see are absent (the server cuts them), so almost everything is optional. */
export type PersonFunction = { functionId: string; rateGrosze?: number | null };
export type Person = {
  id: string;
  version: number;
  name?: string;
  phone?: string;
  email?: string;
  employment?: Employment;
  userId?: string | null;
  /** Whether the linked account is active (null: no account / not known); a deactivated account keeps its person. */
  accountActive?: boolean | null;
  /** Another person (without an account) with the same e-mail: shown as "Możliwy duplikat" until merged. */
  possibleDuplicate?: { id: string; name: string } | null;
  costModel?: CostModel;
  rateGrosze?: number | null;
  notes?: string;
  functions?: PersonFunction[];
};

export type FunctionSummary = { id: string; version: number; name?: string; defaultRateGrosze?: number | null; taskCount: number };
export type Task = { id?: string; title: string; dueOffsetDays: number; priority: Priority };
export type FunctionDetail = { id: string; version: number; name?: string; defaultRateGrosze?: number | null; tasks?: Task[] };

/** "-7" → "7 dni przed", "0" → "w dniu rozpoczęcia", "2" → "2 dni po". */
export function offsetText(days: number): string {
  if (days === 0) return 'w dniu rozpoczęcia';
  const n = Math.abs(days);
  return `${n} ${n === 1 ? 'dzień' : 'dni'} ${days < 0 ? 'przed' : 'po'}`;
}
